export default "__VITE_ASSET__CdHL7_2___"